const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            cancel:             'Cancelar', back: 'Voltar',
            component:          'Ordem de compra',
            component_new:      'Nova ordem de compra',
            component_edit:     'Editar ordem de compra',
            component_list:     'Lista de ordem de compras',
            close:              'Fechar',
            color:              'Cor',
            color_placeholder:  'Introduza a cor',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            field_abreviation:  'Abreviatura',
            field_abreviation_placeholder: 'Introduza a abreviação',
            field_description:  'Descrição',
            field_description_placeholder: 'Introduza a descrição',
            field_id:           'ID',
            field_name:         'Nome',
            field_name_placeholder: 'Introduza o nome',
            field_email:        'E-mail',
            field_vat:          'NIF',
            field_date:         'Data',
            field_canhoes:      'Canhões de neve',
            field_status:       'Estado',
            field_comprimento:  'Comprimento',
            field_comprimento_placeholder: 'Inserir comprimento',
            field_dificuldade:     'Dificuldade',
            field_dificuldade_placeholder: 'Inserir dificuldade',
            field_desnivel:     'Desnível (m)',
            field_desnivel_placeholder: 'Inserir desnível (m)',
            field_n_encomenda:  'N.º',
            field_pagamento_pendente:   'Pagamento',
            field_tem_aula:     'Tem aula',
            field_type:         'Tipo',
            field_total:        'Total',
            muito_facil:        'Muito fácil',
            facil:              'Fácil',
            dificil:            'Difícil',
            muito_dificil:      'Muito difícil',
            pista_balizada:     'Pista Balizada',
            pista_natural:      'Pista Natural',
            snowpark:           'Snowpark',
            not_applicable:     'Não aplicável',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            principal:          'Principal',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            save:               'Salvar',     
            
            numero_licenca:     'N.º de Licença',
        },
    'en':
        {
            add_new:            'Add new',
            calendar:           'Calendar',
            cancel:             'Cancel', back: 'Voltar',
            component:          'Ordem de compra',
            component_new:      'New ordem de compra',
            component_edit:     'Edit ordem de compra',
            component_list:     'List of ordem de compras',
            close:              'Close',
            color:              'Color',
            color_placeholder:  'Insert the color',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            field_abreviation:  'Abreviation',
            field_abreviation_placeholder: 'Insert abreviation',
            field_description:  'Description',
            field_description_placeholder: 'Insert description',
            field_id:           'ID',
            field_name:         'Name',
            field_name_placeholder: 'Insert name',
            field_email:        'E-mail',
            field_vat:          'NIF',
            field_date:         'Data',
            field_canhoes:      'Canhões de neve',
            field_status:       'State',
            field_comprimento:  'Comprimento',
            field_comprimento_placeholder: 'Insert comprimento',
            field_dificuldade:     'Dificuldade',
            field_dificuldade_placeholder: 'Insert dificuldade',
            field_desnivel:     'Desnível (m)',
            field_desnivel_placeholder: 'Insert desnível (m)',
            field_n_encomenda:  'N.º Encomenda',
            field_type:         'Type',
            muito_facil:        'Muito fácil',
            facil:              'Fácil',
            dificil:            'Difícil',
            muito_dificil:      'Muito difícil',
            pista_balizada:     'Pista Balizada',
            pista_natural:      'Pista Natural',
            snowpark:           'Snowpark',
            not_applicable:     'Not applicable',
            id:                 'ID',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            principal:          'Principal',
            remove:             'Remove',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_state:        'State',
            table_actions:      'Actions',
            table_empty:        'no results',
            save:               'Save',
            
            numero_licenca:     'N.º de Licença',
        }
}

module.exports = {
    language
};